import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "about",
  "use": "about-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"about\">\r\n  <path d=\"M12,7c0.8,0,1.5,0.7,1.5,1.5S12.8,10,12,10s-1.5-0.7-1.5-1.5S11.2,7,12,7z M12,12c0.5,0,0.9,0.4,1,0.9l0,0.1v3\r\n\tc0,0.6-0.4,1-1,1c-0.5,0-0.9-0.4-1-0.9l0-0.1v-3C11,12.4,11.4,12,12,12z M12,4c-5.8,0-7.9,2.3-8,8c0,5.9,2.1,8,8,8s8-2.1,8-8\r\n\tC20,6.2,17.7,4.1,12,4z M12,2c7,0,10,3,10,10s-3,10-10,10S2,19,2,12S5,2,12,2z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol